import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'
import { Delete } from '@factorialco/f0-react/icons/app'

interface ApproverSelectionProps {
  onDelete: (strategyId: string) => void
  id: string
  label: string
  avatarUrl?: string
  avatarText?: string
}

export const ApproverSelection = ({
  id,
  label,
  avatarUrl,
  avatarText,
  onDelete,
}: ApproverSelectionProps) => {
  return (
    <Box
      flexDirection="row"
      gap="s8"
      alignItems="center"
      justifyContent="spaceBetween"
      padding="s8"
      borderRadius={{ all: 'abs008' }}
      className="hover:bg-f1-background-hover group"
    >
      <Box flexDirection="row" gap="s8" alignItems="center" width="full">
        <Avatar size="s24" label={avatarText || label} {...(avatarUrl ? { url: avatarUrl } : {})} />
        <Text size="200" weight="medium">
          {label}
        </Text>
      </Box>
      <Delete
        width={20}
        height={20}
        onClick={() => onDelete(id)}
        className="opacity-0 group-hover:opacity-100 cursor-pointer text-f1-foreground-critical hover:text-f1-foreground-critical-hover"
      />
    </Box>
  )
}
